<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9YRpf6/images/cover.jpg?1684871088845" alt="This image is the cover for the book Grounded in Heaven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grounded in Heaven
      </h1>
      <p class="bookDescription body article font2">
        <p>Eschatology and ethics are joined at the hip, says Michael Allen, and both need theocentric reorientation. In <i>Grounded in Heaven </i>Allen retrieves the traditional concept of the beatific vision and seeks to bring Christ back into the heart of our theology and our lives on earth.</p><p>Responding to the earthly-mindedness of much recent theology, Allen places his focus on God and the heavenly future while also appreciating ways in which the Reformed tradition provides a unique angle on broadly catholic concerns. Reaching back to classical ethics as well as its reformation by Calvin and other Reformed theologians, <i>Grounded in Heaven </i>offers a distinctly Protestant account of the ascetical calling to be heavenly-minded and to deny one’s self.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Allen
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Michael Allen</B>&#160;is John Dyer Trimble Professor of Systematic Theology and academic dean at Reformed Theological Seminary in Orlando, Florida. He is the author of numerous books, including&#160;<I>Grounded in Heaven</I>, and the coeditor, with Scott R. Swain, of&#160;<I>The Oxford Handbook of Reformed Theology</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?259f20c2